import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {
  public frameSrc: string = "";
  public termType: string = "";
  public sanitizedUrl: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer, 
    public dataSvc: DataService) { }

  ngOnInit() {
    // 
  }

  reject() {
    window.location.href = '/login.aspx'
  }

  setFrameSrc(src, type) {
    this.frameSrc = src;
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(src);
    this.termType = type;
  }
}